<div class="buttons_div" id="buttons_layers" style="display: inline-flex">
  <ul class="nav nav-tabs">
    <ng-container *ngFor="let b of boundaries; index as i">
      <li
        [ngClass]="
          active[i] === true
            ? 'multi_layer_buttons active'
            : 'multi_layer_buttons'
        "
        (click)="showData(b.id.toString(), i)"
        *ngIf="layer_id.includes(b.id.toString())"
      >
        <a data-toggle="tab" class="layer_name">{{ b.name }}</a>
      </li>
    </ng-container>
  </ul>
</div>
<div
  id="table_multi_layers"
  class="tab-pane fade in active"
  style="display: block"
>
  <!-- Data Single -->
  <div *ngIf="!multipleData">
    <table
      id="data-view-tbl"
      class="fixed data-view-tbl data-view-tbl-2541"
      style="display: block"
      layer="2541"
    >
      <thead>
        <tr>
          <th *ngIf="labels.length > 0">Selection ID</th>
          <ng-container
            *ngFor="let key of makeData.fields | keyvalue; index as i"
          >
            <th *ngIf="makeData.fields[keys[i]] !== 'Last Sale'">
              {{ makeData.fields[keys[i]] }}
            </th>
            <th *ngIf="makeData.fields[keys[i]] === 'Last Sale'">Deed Date</th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr fid="112635" class="item">
          <td *ngIf="labels.length > 0">{{ labels[0] }}</td>
          <ng-container
            *ngFor="let key of makeData.fields | keyvalue; index as i"
          >
            <td [innerHTML]="makeData.data[keys[i]]">
              {{ makeData.data[keys[i]] }}
            </td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
  <!-- Data Multiple -->
  <div *ngIf="multipleData">
    <table
      id="data-view-tbl"
      class="fixed data-view-tbl data-view-tbl-2541"
      style="display: block"
      layer="2541"
    >
      <thead>
        <tr>
          <th *ngIf="labels.length > 0">Selection ID</th>
          <ng-container
            *ngFor="let key of makeData[0].fields | keyvalue; index as i"
          >
            <th *ngIf="makeData[0].fields[keys[i]] !== 'Last Sale'">
              {{ makeData[0].fields[keys[i]] }}
            </th>
            <th *ngIf="makeData[0].fields[keys[i]] === 'Last Sale'">
              Deed Date
            </th>
          </ng-container>
        </tr>
      </thead>
      <tbody>
        <tr class="item" *ngFor="let data of makeData; index as p">
          <td *ngIf="labels.length > 0">{{ labels[p] }}</td>
          <ng-container *ngFor="let key of data.data | keyvalue; index as i">
            <td [innerHTML]="data.data[keys[i]]">{{ data.data[keys[i]] }}</td>
          </ng-container>
        </tr>
      </tbody>
    </table>
  </div>
</div>

